import { VariantIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import { ICellRendererParams } from "ag-grid-community";
import clsx from "clsx";
import React from "react";
import { InventoryRow, ProductObject } from "types";
import { xolaUri } from "@/api/xolaUri";
import { ProductImage } from "@/components/Common/ProductImage";

export const InventoryProductCell = ({ data }: ICellRendererParams<InventoryRow>) => {
    if (!data) {
        return null;
    }
    return (
        <div className="flex items-center gap-2 py-1">
            <ProductImage
                product={{
                    id: data.productId,
                    name: data.productName,
                    object: ProductObject.WARE,
                    ...(data.productPhotoId && { photo: { id: data.productPhotoId } }),
                }}
                src={data.thumbnailUrl ? `${xolaUri}${data.thumbnailUrl}` : undefined}
                size="small"
                className="!mr-0 flex-shrink-0"
            />

            <div className="min-w-0">
                <p className={clsx("no-translate h-8 truncate font-bold", data.isDeleted && "text-gray-dark")}>
                    {data.productName}
                </p>
                <div className="flex h-8 items-center gap-1 text-xs text-gray-dark">
                    <VariantIcon className="h-3 w-3 flex-shrink-0 text-gray-dark" />
                    <span className={clsx("no-translate", data.isDeleted && "text-gray-dark")}>
                        {data.variantLabel}
                    </span>
                    {data.isDraft && (
                        <Badge color="primary" size="small">
                            Draft
                        </Badge>
                    )}
                    {data.isDeleted && (
                        <Badge color="secondary" size="small">
                            Deleted
                        </Badge>
                    )}
                </div>
            </div>
        </div>
    );
};
